import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { Chip, Input } from '@mui/material';
import React from 'react';
import { UserRole } from '../../../models/users/User';
import { getRoleName } from '../../../utility/users';
import { OrderStatus } from '../../../models/orders/Order';
import { getStatusName } from '../../../utility/orders';
import { Status } from './Status';

interface Props {
  selected: number[];
  setSelected: (values: number[]) => void;
}

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export const StatusFilter: React.FC<Props> = ({ selected, setSelected }: Props) => {
  const handleChange = (event: SelectChangeEvent<typeof selected>) => {
    const {
      target: { value },
    } = event;
    setSelected(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',').map((x: string) => parseInt(value)) : value
    );
  };

  return (
    <div>
      <FormControl fullWidth>
        <InputLabel id="status-label">Státus szűrő</InputLabel>
        <Select
          labelId="status-label"
          id="status-filter"
          multiple
          variant="standard"
          value={selected}
          onChange={handleChange}
          input={<Input id="select-multiple-status" />}
          renderValue={(values) => (
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
              {values.map((value: number) => (
                <React.Fragment key={value}>
                  <Status data={value} />
                </React.Fragment>
              ))}
            </Box>
          )}
          MenuProps={MenuProps}
        >
          {Object.keys(OrderStatus)
            .filter((key: any) => !isNaN(Number(OrderStatus[key])))
            .map((key) => {
              const value = (OrderStatus as any)[key];
              const label = getStatusName(value);
              return (
                <MenuItem key={value} value={value}>
                  {label}
                </MenuItem>
              );
            })}
        </Select>
      </FormControl>
    </div>
  );
};
